import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { fetchVisitorTypes, fetchMeetingVenues, insertAppointment, fetchGateDetails, fetchNationality, fetchBuildingsByGate, fetchIdProofTypes } from '../../services/Api';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { linkMailAndSms } from '../../services/Api';
import UsernameContext from '../../components/auth/UsernameContext';
import axios from 'axios';
import { AppIdContext } from './AppIdContext';
import CryptoJS from 'crypto-js';
import moment from 'moment/moment';
import { format } from 'date-fns'; // Import the format function from date-fns
import { useLocation } from 'react-router-dom';



const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 18px 7px 33px;
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Heading = styled.h1`
  font-size: 25px;
  font-family: 'Segoe UI', Semibold;
  margin: 0;
  color:#2B3497;
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  width: 81px;
  height: 32px;
  border-radius: 7px;
  box-shadow: 0px 5px 10px #2B349754;
  color: white;
  font-size: 14px;
  border: none;
  cursor: pointer;
  font-family: 'Segoe UI', Semibold;
`;

const ResetButton = styled(Button)`
  background-color: red;
`;

const SubmitButton = styled(Button)`
  background-color: #2B3497;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
  @media (max-width: 1920px) {
    display:flex;
    justify-content: space-evenly;
  }
`;

const Card = styled.div`
  width: 420px;
  background: #fff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 27px;
  opacity: 1;
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
  @media (max-width: 1920px) {
    width: 100%;
    height: auto;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  font-family: 'Segoe UI', Semibold;
  color:#000000;
  margin-bottom: 5px;
  font-weight:600;
`;

const Asterisk = styled.span`
  color: red;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;
const FormRow = styled.div`
  display: flex;
  gap: 20px; /* Adjust spacing between inputs */
  justify-content: space-between;
  width: 100%;
`;

const Select = styled.select`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;

const StyledDatePicker = styled(DatePicker)`
  width: 415px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    padding: 8px 0;
    border: none;
    font-family: 'Segoe UI', Regular;
    background: transparent;
    border-bottom: 1px solid #2B3497;
    &:focus {
      outline: none;
      border-bottom: 2px solid #2B3497;
    }
  }
  @media (max-width: 1920px) {
    width: 745px;
  }
  @media (max-width: 1820px) {
    width: 689px;
  }
  @media (max-width: 1720px) {
    width: 644px;

  }
       @media (max-width: 1620px ) {
    width: 587px;

  }
           @media (max-width: 1520px ) {
    width: 587px;

  }
           @media (max-width: 1420px ) {
    width: 487px;

  }
             @media (max-width: 1220px ) {
    width: 387px;

  }
`;

// Tabs container
const Tabs = styled.div`
  display: flex;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
`;

const Tab = styled.button`
  background: none;
  border: none;
  font-family: 'Segoe UI', Semibold;
  padding: 10px 20px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #000;
  &:hover {
    color: #2B3497;
  }
  ${({ active }) => active && `
    border-bottom: 2px solid #2B3497;
    color: #2B3497;
  `}
`;

const TabContent = styled.div`
  display: ${({ active }) => (active ? 'block' : 'none')};
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  color: red;
  font-family: 'Segoe UI', Semibold;
  font-size: 14px;
`;

const HeaderN = styled.h3`
  margin-top: 16px;
  color: ${(props) => (props.disabled ? '#a9a9a9' : '#2B3497')}; /* Change color if disabled */
`;

const DropdownContainer = styled.div`
  margin-top: 16px;
`;

const DropdownLabel = styled.label`
  font-weight: 600;
  margin-right: 8px;
`;

const StyledDropdown = styled.select`
  padding: 10px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #293495;
    outline: none;
  }

  option {
    padding: 8px;
  }
`;

const InputContainer = styled.div`
  margin-top: 16px;
  display: ${(props) => (props.show ? 'flex' : 'none')};
  gap:14px
`;

const SpinnerInput = styled.input`
  padding: 10px;
  width: 60px;
  text-align: center;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #293495;
    outline: none;
  }
`;

const SpinnerInputLabel = styled.label`
  font-weight: 600;
`;

const RecurrenceInput = styled.input`
  padding: 10px;
  width: 80px;
  text-align: center;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  margin-left: 8px;

  &:focus {
    border-color: #293495;
    outline: none;
  }
`;

const AdditionalInputContainer = styled.div`
  margin-top: 16px;
  display: ${(props) => (props.show ? "flex" : "none")};
  flex-direction: column;
  align-items: flex-start;
`;
const SelectedValuesContainer = styled.div`
  margin-top: 10px;
  padding: 12px;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
`;

const SelectedHeader = styled.h4`
  margin-bottom: 11px;
  font-weight: bold;
  color: #293495;
`;

const ValueRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const SelectedValue = styled.div`
  font-weight: bold;
  color: #000;
`;

const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SwitchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SwitchLabel = styled.label`
  font-weight: 600;
  font-size: 16px;
`;

const Switch = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const SwitchText = styled.span`
  font-weight: bold;
  margin-left: 10px;
  color: ${({ isOn }) => (isOn ? '#28a745' : '#6c757d')}; // Green for Yes, Gray for No
`;

const SwitchSlider = styled.div`
  width: 50px;
  height: 24px;
  background-color: ${({ isOn }) => (isOn ? '#28a745' : '#ccc')}; // Green for Yes, Gray for No
  border-radius: 34px;
  position: relative;
  transition: 0.4s;

  &:before {
    content: '';
    position: absolute;
    height: 20px;
    width: 20px;
    left: ${({ isOn }) => (isOn ? '26px' : '4px')}; // Moves the slider based on the toggle state
    bottom: 2px;
    background-color: white;
    border-radius: 50%;
    transition: 0.4s;
  }
`;

const InputFieldContainer = styled.div`
  margin-top: 20px;
`;

const InputLabel = styled.label`
  font-weight:600;
  margin-bottom: 5px;
  display: block;
`;
const InputLabelN = styled.label`
  margin-bottom: 5px;
  display: block;
  font-weight:600;
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Arial', sans-serif;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
  box-sizing: border-box;
  resize: vertical;

  &:focus {
    border-color: #28a745;
  }
`;
const Checkbox = styled.input`
width: 20px;  /* Increases the size of the checkbox */
  height: 20px;
  margin-right: 8px;
`;
const CheckboxLabel = styled.span`
  font-weight: 500;
  color: #000;
  font-size: 16px;
  margin-right: 8px; /* Adds space between the label and checkbox */
`;
const CheckboxContainernew = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 2fr)); /* Creates responsive grid */
  gap: 10px; /* Adds space between checkboxes */
  max-width:420px; /* Adjust the width as needed */
`;
const CheckboxContainernewM = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 2fr)); /* Creates responsive grid */
  gap: 10px; /* Adds space between checkboxes */
  max-width:500px; /* Adjust the width as needed */
`;
const CheckboxLabelnew = styled.span`
  display: inline-flex;
  align-items: center;  /* Ensures vertical alignment of the checkbox and text */
  gap: 8px;            /* Adds space between the checkbox and text */
  font-size: 14px;     /* Adjust based on your preferred font size */
  margin: 5px 0;
  font-weight: 400;
  color: #000;

`;

const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  z-index: 1000;
  width: 500px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  cursor: pointer;
  margin-left: 10px;
  &.no-button {
    background-color: red; /* Change color to red for No button */
  }
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;

const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
`;

const Chip = styled.div`
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 16px;
  padding: 5px 10px;
  margin: 2px;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

const RemoveChipButton = styled.span`
  color: #ff0000;
  font-weight: bold;
  margin-left: 5px;
  cursor: pointer;
`;

const InputField = styled.input`
  border: none;
  outline: none;
  flex: 1;
  font-size: 14px;
  margin-left: 5px;
  padding: 5px;
`;

const SuggestionBox = styled.ul`
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 5px 0 0;
  padding: 0;
  list-style: none;
  background: white;
  max-height: 150px;
  overflow-y: auto;
`;

const SuggestionItem = styled.li`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;
const AdditionalInputContainerN = styled.div`
  margin-top: 16px;
  margin-bottom: 10px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;



const BookAppointment = () => {
  const { username } = useContext(UsernameContext); // Access username from context
  const [appId, setAppId] = useState(null);
  const [activeTab, setActiveTab] = useState('details'); // State for tab manage

  const [linkMailAndSmsResponse, setLinkMailAndSmsResponse] = useState(null);

  const [selectedGate, setSelectedGate] = useState('');
  const [selectedVisitorType, setSelectedVisitorType] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [userId, setUserId] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [recurrencePattern, setRecurrencePattern] = useState('');
  const [selectedrecurrencePattern, setSelectedrecurrencePattern] = useState('');
  const [recurrencePatternAPI, setRecurrencePatternAPI] = useState('');
  const [selectedDay, setSelectedDay] = useState('');
  const [selectedWeekday, setSelectedWeekday] = useState('');
  const [selectedWeekdayAPI, setSelectedWeekdayAPI] = useState('');

  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedMonthAPI, setSelectedMonthAPI] = useState('');


  const [isAllDayChecked, setIsAllDayChecked] = useState(false);
  const [isBlockCalenderChecked, setIsBlockCalenderChecked] = useState(false);

  const [recurEvery, setRecurEvery] = useState(0);

  const [isAssistanceRequired, setIsAssistanceRequired] = useState(false);
  const [isServiceProviderAccess, setIsServiceProviderAccess] = useState(false);
  const [isWiFiRequired, setIsWiFiRequired] = useState(false);
  const [isEscortRequired, setIsEscortRequired] = useState(false);
  const [isadditionalNotify, setIsAdditionalNotify] = useState(false);
  const [isbehalfNotify, setIsBehalfNotify] = useState(false);


  const [additionalMessage, setAdditionalMessage] = useState('');
  const [checkInInstructions, setCheckInInstructions] = useState('');

  const toggleAssistanceRequired = () => setIsAssistanceRequired(!isAssistanceRequired);
  const toggleServiceProviderAccess = () => setIsServiceProviderAccess(!isServiceProviderAccess);
  const toggleWiFiRequired = () => setIsWiFiRequired(!isWiFiRequired);
  const toggleEscortRequired = () => setIsEscortRequired(!isEscortRequired);
  const toggleadditionalNotifyRequired = () => setIsAdditionalNotify(!isadditionalNotify);
  const togglebehalfNotifyRequired = () => setIsBehalfNotify(!isbehalfNotify);


  const handleAdditionalMessageChange = (e) => setAdditionalMessage(e.target.value);
  const handleCheckInInstructionsChange = (e) => setCheckInInstructions(e.target.value);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [fieldData, setFieldData] = useState('');
  const [selectedIdProofType, setSelectedIdProofType] = useState('');

  const [idProofTypes, setIdProofTypes] = useState([]);

  const location = useLocation();
  const { visitorTypeDetails } = location.state || {};
  console.log("visitorTypeDetails", visitorTypeDetails);

  const [timeLimits, setTimeLimits] = useState({ startHour: 9, startMinute: 0, endHour: 18, endMinute: 0 });





  const handleCheckboxChange = () => {
    setIsChecked((prev) => !prev);
  };
  const handleDropdownChange = (event) => {
    console.log("event.target", event.target);
    const selectedText = event.target.options[event.target.selectedIndex].text;
    console.log("selectedText", selectedText);
    // This gets the text of the selected option

    setRecurrencePattern(event.target.value);
    if (event.target.value == "1") {
      setRecurrencePatternAPI(1);
    }
    if (event.target.value == "2") {
      setRecurrencePatternAPI(2);
    }
    if (event.target.value == "3") {
      setRecurrencePatternAPI(3);
    }
  };
  const handleDayChange = (event) => {
    setSelectedDay(event.target.value);
  };
  const handleWeekdayCheckboxChange = (weekday) => {
    setSelectedWeekday((prev) =>
        prev.includes(weekday)
          ? prev.filter((day) => day !== weekday) // Remove if already selected
        : [...prev, weekday] // Add if not selected
    );
  };
  const handleMonthCheckboxChange = (month) => {
    setSelectedMonth((prev) =>
        prev.includes(month)
          ? prev.filter((m) => m !== month) // Remove if already selected
        : [...prev, month] // Add if not selected
    );
  };
  const handleAllDayCheckboxChange = () => {
    setIsAllDayChecked((prev) => !prev);
  };
  const handleBlockCalenderCheckboxChange = () => {
    setIsBlockCalenderChecked((prev) => !prev);
  };

  const handleRecurEveryChange = (event) => {
    const value = event.target.value;
    if (value === "" || (!isNaN(value) && Number(value) >= 0)) {
      setRecurEvery(value === "" ? 0 : Number(value));
    }
  };

  const handleRecurEveryKeyDown = (event) => {
    // Reverse the arrow key behavior
    if (event.key === "ArrowUp") {
      event.preventDefault();
      setRecurEvery((prev) => Math.max(0, Number(prev || 0) - 1)); // Decrease on up arrow
    } else if (event.key === "ArrowDown") {
      event.preventDefault();
      setRecurEvery((prev) => Number(prev || 0) + 1); // Increase on down arrow
    }
  };

  const getRecurrencePatternAPIValue = () => {
    switch (recurrencePattern) {
      case "1":
        return 1;
      case "2":
        return 2;
      case "3":
        return 3;
      default:
        return null; // Handle default case as needed
    }
  };


  const [defaultCode, setDefaultCode] = useState({})
  const [formData, setFormData] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    // visitorName: '',
    gender: '',
    visitorEmail: '',
    nationality: '',
    visitorMobile: '',
    selectedVisitorTypeId: selectedVisitorType,
    idProofId: selectedIdProofType || 0,
    purpose: '',
    meetingOn: null,
    meetingTo: null,
    meetingvenue: '',
    gate: '',
    building: '',
    employeeId: '',
    isCoupon: '0',
    visitorIdNumber: ''
  });

  const [employeeData, setEmployeeData] = useState([]); // To store the employee data

  useEffect(() => {
    if (username) {
      fetchEmployeeMail(username);
      localStorage.setItem('username', username); // Store the username in local storage

    }
    setFieldData(visitorTypeDetails.individualAppointmentInputField[0])
    setCheckInInstructions(visitorTypeDetails?.checkinInstruction || '')


    console.log("individualAppointmentInputField", fieldData);
    const fetchAppointmentDataeemp = async () => {
      try {
        const responseeEMP = await axios.get('/Employee/')
        console.log("response", responseeEMP);
        console.log('Employee Data:', responseeEMP.data);
        setEmployeeData(responseeEMP.data);
      } catch (error) {
        console.error('Error fetching appointment data:', error);
      }
    };
    fetchAppointmentDataeemp()

  }, [username]);

  // const emailOptions = employeeData.map((employee) => ({
  //   email: employee.employeeMailId,
  //   name: employee.employeeName,
  // }));

  const [inputValue, setInputValue] = useState('');
  const [inputValueBehalf, setInputValueBehalf] = useState("");
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [onBehalfEmail, setOnBehalfEmail] = useState("");
  const [filteredBehalfSuggestions, setFilteredBehalfSuggestions] = useState([]);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);


  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    // Filter suggestions only if input is not empty
    if (value) {
      setFilteredSuggestions(
        employeeData.filter(
          (emp) =>
            emp.employeeMailId &&
            emp.employeeMailId.toLowerCase().includes(value.toLowerCase())
        )
      );
    } else {
      setFilteredSuggestions([]);
    }
  };

  const handleSuggestionClick = (email) => {
    if (!selectedEmails.includes(email)) {
      setSelectedEmails((prev) => [...prev, email]);
    }
    setInputValue('');
    setFilteredSuggestions([]);
  };
  const handleBehalfInputChange = (e) => {
    const value = e.target.value;
    setInputValueBehalf(value);

    if (value) {
      setFilteredBehalfSuggestions(
        employeeData.filter(
          (emp) =>
            emp.employeeMailId &&
            emp.employeeMailId.toLowerCase().includes(value.toLowerCase())
        )
      );
    } else {
      setFilteredBehalfSuggestions([]);
    }
    // const suggestions = employeeData.filter((emp) =>
    //   emp.employeeMailId.toLowerCase().includes(value.toLowerCase())
    // );
    // setFilteredBehalfSuggestions(suggestions);
  };
  const [onBehalfEmployeeId, setOnBehalfEmployeeId] = useState(null); // NEW

  const handleBehalfSuggestionClick = (email) => {
    const selectedEmp = employeeData.find(
      (emp) => emp.employeeMailId === email,
    );

    console.log("selectedEmp", selectedEmp);

    if (selectedEmp) {
      setOnBehalfEmail(selectedEmp.employeeMailId);
      setOnBehalfEmployeeId(selectedEmp.id); // Set the ID
    }
    setInputValueBehalf("");
    setFilteredBehalfSuggestions([]);
  };

  const handleChipRemove = (email) => {
    setSelectedEmails((prev) => prev.filter((e) => e !== email));
  };
  useEffect(() => {
    // Log the selected emails to the console whenever they update
    console.log("Selected Emails:", selectedEmails);

  }, [selectedEmails]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && inputValue && !selectedEmails.includes(inputValue)) {
      setSelectedEmails((prev) => [...prev, inputValue]);
      setInputValue('');
      setFilteredSuggestions([]);
    }
  };

  const fetchEmployeeMail = async (username) => {
    try {
      const response = await axios.get(`/User/UserDets/${username}`);
      console.log('response', response.data);
      if (response.data.length > 0) {
        setUserId(response.data[0].id);
        localStorage.setItem("USERID", response.data[0].id);
        setEmployeeId(response.data[0].empId);
      } else {
        console.error("No user data found for username:", username);
        // Optionally handle case where no data is found
      }
    } catch (error) {
      console.error("Error fetching employee email:", error);
    }
  };

  useEffect(() => {
    if (userId) {
      const storedUserId = localStorage.getItem("USERID");
      if (storedUserId !== userId) {
        console.warn(
          `Mismatch: localStorage USERID (${storedUserId}) differs from userId (${userId})`,
        );
      }
    }
    console.log("userId", userId);
  }, [userId]);

  useEffect(() => {
    if (employeeId) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        employeeId,
      }));
    }
    console.log("employeeId", employeeId);
  }, [employeeId]);

  const [visitorTypes, setVisitorTypes] = useState([]);
  const [meetingvenues, setMeetingvenues] = useState([]);
  const [nationalityList, setNationalityList] = useState([]);

  const [gates, setGates] = useState([]);
  const [buildings, setBuildings] = useState([]);

  const [formErrors, setFormErrors] = useState({
    firstName: fieldData.visitorNameField,
    lastName: fieldData.visitorNameField,
    // visitorName: false,
    gender: fieldData.genderField,
    nationality: fieldData.nationalityField,
    visitorEmail: fieldData.visitorEmailField,
    visitorMobile: fieldData.visitorMobileField,
    selectedVisitorTypeId: false,
    purpose: fieldData.purpose,
    meetingOn: fieldData.meetingOnField,
    meetingTo: fieldData.meetingToField,
    meetingvenue: fieldData.locationField,
    gate: fieldData.gateField,
    building: fieldData.areaField,
    idProofId: fieldData.idProofTypeField,
    visitorIdNumber: fieldData.idProofNumberField,
  });

  const handleReset = () => {
    setSelectedGate("");
    setSelectedEmails([]); // Clear the selected email chips
    setInputValue("");
    setFormData((prev) => ({
      ...prev,
      firstName: "",
      middleName: "",
      lastName: "",
      gender: "",
      visitorEmail: "",
      visitorMobile: "",
      nationality: "",
      purpose: "",
      meetingOn: null,
      meetingTo: null,
      meetingvenue: "",
      gate: "",
      building: "",
      idProofId: prev.idProofId, // preserve idProofId too
      visitorIdNumber: "",
      // ✅ keep selectedVisitorTypeId unchanged
      selectedVisitorTypeId: prev.selectedVisitorTypeId,
    }));
    setFormErrors({
      firstName: false,
      middleName: false,
      lastName: false,
      // visitorName: false,
      gender: false,
      visitorEmail: false,
      nationality: "",
      visitorMobile: false,
      // selectedVisitorTypeId: false,
      purpose: false,
      meetingOn: false,
      meetingTo: false,
      meetingvenue: false,
      gate: false,
      building: false,
      idProofId: false,
      visitorIdNumber: false,
    });

    setIsChecked(false);
    setRecurrencePattern(""); // Set to default value (1 for Daily)
    setSelectedDay("");
    setSelectedWeekday("");
    setSelectedMonth("");
    setRecurEvery("");
    setIsAllDayChecked(false);
    setIsBlockCalenderChecked(false);
    setIsAssistanceRequired(false);
    setIsServiceProviderAccess(false);
    setIsWiFiRequired(false);
    setIsEscortRequired(false);
    setAdditionalMessage("");
    setCheckInInstructions("");
    setIsAdditionalNotify("");
    setIsBehalfNotify("");

    console.log("Form reset");
  };
  const navigate = useNavigate();

  const [existingData, setExistingData] = useState("");
  const [blackData, setBlackData] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    let recurrencePattern = getRecurrencePatternAPIValue();

    let newSelectedRecurrencePattern = "";

    // Determine the selected recurrence pattern based on the recurrencePatternAPI value
    if (recurrencePattern === 1) {
      newSelectedRecurrencePattern = "";
    } else if (recurrencePattern === 2) {
      newSelectedRecurrencePattern = selectedWeekday;
    } else if (recurrencePattern === 3) {
      newSelectedRecurrencePattern = selectedMonth;
    }
    if (isChecked == 1) {
      if (recurrencePatternAPI) {
        // if (recurrencePatternAPI == 1 && !recurEvery) {
        //   toast.error("Please fill the recur every field");
        //   return;
        // }
        if (recurrencePatternAPI == 2 && !newSelectedRecurrencePattern) {
          toast.error("Please  Select the Weekdays");
          return;
        }
        if (recurrencePatternAPI == 3 && !newSelectedRecurrencePattern) {
          toast.error("Please  Select the Months");
          return;
        }
      } else {
        toast.error("Please select the recurrence pattern");
        return;
      }
    }
    // Perform validation before submitting
    let valid = true;
    const errors = {};

    // Validate required fields
    // if (formData.visitorName === '') {
    //   errors.visitorName = true;
    //   valid = false;
    // }
    if (fieldData.visitorNameField && formData.firstName === "") {
      errors.firstName = true;
      valid = false;
    }
    if (fieldData.visitorNameField && formData.lastName === "") {
      errors.lastName = true;
      valid = false;
    }
    if (fieldData.visitorEmailField && formData.visitorEmail === "") {
      errors.visitorEmail = true;
      valid = false;
    }
    if (fieldData.genderField && formData.gender === "") {
      errors.gender = true;
      valid = false;
    }
    if (fieldData.visitorMobileField && formData.visitorMobile === "") {
      errors.visitorMobile = true;
      valid = false;
    }
    if (formData.selectedVisitorTypeId === "") {
      errors.selectedVisitorTypeId = true;
      valid = false;
    }
    if (fieldData.purpose && formData.purpose === "") {
      errors.purpose = true;
      valid = false;
    }
    if (fieldData.meetingOnField && formData.meetingOn === null) {
      errors.meetingOn = true;
      valid = false;
    }
    if (fieldData.meetingToField && formData.meetingTo === null) {
      errors.meetingTo = true;
      valid = false;
    }
    if (fieldData.locationField && formData.meetingvenue === "") {
      errors.meetingvenue = true;
      valid = false;
    }
    if (fieldData.gateField && formData.gate === "") {
      errors.gate = true;
      valid = false;
    }
    if (fieldData.nationalityField && formData.nationality === "") {
      errors.nationality = true;
      valid = false;
    }
    if (fieldData.areaField && formData.building === "") {
      errors.building = true;
      valid = false;
    }
    if (fieldData.idProofTypeField && formData.idProofId === "") {
      errors.idProofId = true;
      valid = false;
    }
    if (fieldData.idProofNumberField && formData.visitorIdNumber === "") {
      errors.visitorIdNumber = true;
      valid = false;
    }

    // Validate email format
    if (formData.visitorEmail !== "") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.visitorEmail)) {
        errors.visitorEmail = true;
        valid = false;
      }
    }

    // Validate mobile number format
    if (isadditionalNotify) {
      if (selectedEmails == "") {
        toast.error("please fill the message to notify field");
        return;
      }
    }
    if (isbehalfNotify) {
      if (onBehalfEmail == "") {
        toast.error("please fill the message to on behalf field");
        return;
      }
    }
    // Validate meetingOn and format it to "yyyy-MM-dd HH:mm:ss"
    if (formData.meetingOn !== null) {
      const formattedMeetingOn = format(
        new Date(formData.meetingOn),
        "yyyy-MM-dd HH:mm:ss",
      );
      formData.meetingOn = formattedMeetingOn;
    } else {
      errors.meetingOn = true;
      valid = false;
    }
    // Validate meetingTo and format it to "yyyy-MM-dd HH:mm:ss"
    if (formData.meetingTo !== null) {
      const formattedMeetingTo = format(
        new Date(formData.meetingTo),
        "yyyy-MM-dd HH:mm:ss",
      );
      formData.meetingTo = formattedMeetingTo;
    } else {
      errors.meetingTo = true;
      valid = false;
    }

    // Validate meeting times
    if (!validateMeetingTimes()) {
      valid = false;
    }

    // Update form errors state
    setFormErrors(errors);

    // Prevent form submission if validation fails
    if (!valid) {
      console.log("Form has errors:", errors);
      return; // Exit function if form is invalid
    }
    if(activeTab == "details"){
      setActiveTab("additional");
      return;
    }

    const empIDget = localStorage.getItem("employeeId");
    const toLocalISOString = (date) => {
      const tzOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
      const localISOTime = new Date(date - tzOffset).toISOString().slice(0, -1); // Remove 'Z' at the end
      return localISOTime + "Z"; // Add 'Z' at the end
    };
    const dateSend = toLocalISOString(new Date(formData.meetingOn));
    const formattedMobileNumber = `${defaultCode}-${formData.visitorMobile}`;
    if (formData.visitorMobile) {
      const blackListCheck = await axios.get(
        `/BlackList/${formattedMobileNumber}`,
      );
      console.log("blackListCheck", blackListCheck);
      setBlackData(blackListCheck.data);
    }
    if (blackData) {
      toast.error("Person with this mobile number is blacklisted");
      return;
      // Show the popup when the icon is clicked
    }

    const setHost = await axios.get(
      `/Appointment/GetAppointmentbyHost/${empIDget},${dateSend}`,
    );
    console.log("setHost", setHost);

    const checkValidation = await axios.get(
      `/Appointment/Appointments/${formattedMobileNumber}`,
    );
    if (
      checkValidation.data ==
      "You are not allowed to check-in this visitortype, Please contact administrator."
    ) {
      toast.error(
        "You are not allowed to check-in this visitortype, Please contact administrator.",
      );
      return;
    }
    console.log("checkValidation", checkValidation);

    setExistingData(checkValidation?.data);

    console.log("blackData", blackData);

    if (
      formData.visitorMobile == checkValidation?.data.visitorMobile &&
      formData.firstName !== checkValidation?.data.visitorName
    ) {
      setPopupVisible(true);
    } else {
      // Check if the appointment can be booked for the selected time
      try {
        const response = await axios.get(
          `/Appointment/GetAppointmentbyHost/${employeeId},${formData.meetingOn}`,
        );

        if (
          response.data &&
          response.data.some((appointment) => {
            const formattedExistingMeetingOn = new Date(appointment.meetingOn)
              .toISOString()
              .slice(0, 19)
              .replace("T", " ");
            const formattedExistingValidTill = new Date(appointment.validTill)
              .toISOString()
              .slice(0, 19)
              .replace("T", " ");
            const formattedFormMeetingOn = new Date(formData.meetingOn)
              .toISOString()
              .slice(0, 19)
              .replace("T", " ");

            // Check if the selected meetingOn time matches an existing appointment's meetingOn or validTill
            return (
              formattedExistingMeetingOn === formattedFormMeetingOn ||
              formattedExistingValidTill === formattedFormMeetingOn
            );
          })
        ) {
          setPopupVisible(false);

          toast.error(
            "An appointment already exists for the selected time. Please choose another time slot.",
          );

          return; // Exit function if the appointment cannot be booked
        }
      } catch (error) {
        console.error("Error checking appointment availability:", error);
        toast.error(
          "Failed to check appointment availability. Please try again.",
        );
        return; // Exit function if there's an error in checking availability
      }

      // Convert date to ISO 8601 format with local time
      const toLocalISOString = (date) => {
        const tzOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
        const localISOTime = new Date(date - tzOffset)
          .toISOString()
          .slice(0, -1); // Remove 'Z' at the end
        return localISOTime + "Z"; // Add 'Z' at the end
      };
      let recurrencePattern = getRecurrencePatternAPIValue();

      let newSelectedRecurrencePattern = "";

      // Determine the selected recurrence pattern based on the recurrencePatternAPI value
      if (recurrencePattern === 1) {
        newSelectedRecurrencePattern = "";
      } else if (recurrencePattern === 2) {
        newSelectedRecurrencePattern = selectedWeekday;
      } else if (recurrencePattern === 3) {
        newSelectedRecurrencePattern = selectedMonth;
      }
      if (isChecked == 1) {
        if (recurrencePatternAPI) {
          // if (recurrencePatternAPI == 1 && !recurEvery) {
          //   toast.error("Please fill the recur every field");
          //   return;
          // }
          if (recurrencePatternAPI == 2 && !newSelectedRecurrencePattern) {
            toast.error("Please  Select the Weekdays");
            return;
          }
          if (recurrencePatternAPI == 3 && !newSelectedRecurrencePattern) {
            toast.error("Please  Select the Months");
            return;
          }
        } else {
          toast.error("Please select the recurrence pattern");
          return;
        }
      }

      // Log the new selected recurrence pattern before setting the state
      console.log(
        "Selected Recurrence Pattern before update:",
        newSelectedRecurrencePattern,
      );
      const formattedEmails = selectedEmails.join(", ");
      console.log("Submitting Emails:", formattedEmails);
      const formDataAdditional = {
        repeatVisit: isChecked,
        recurrencePattern: recurrencePatternAPI,
        selectedRecurrence: String(newSelectedRecurrencePattern),
        selectedDay: selectedDay,
        selectedWeekday: selectedWeekdayAPI,
        selectedMonth: selectedMonthAPI,
        recurEvery: recurEvery,
        allDay: isAllDayChecked,
        blockCalendar: isBlockCalenderChecked,
        assistanceRequired: isAssistanceRequired,
        serviceProviderAccess: isServiceProviderAccess,
        wifiRequired: isWiFiRequired,
        escortRequired: isEscortRequired,
        additionalNotification: isadditionalNotify || false,
        isOnBehalfOf: isbehalfNotify || false,
        onBehalfEmployeeId: onBehalfEmployeeId,
        additionalMessage: additionalMessage,
        checkInInstructions: checkInInstructions,
      };
      const checkData = {};
      console.log("FormData", formData);

      const empIDget = localStorage.getItem("employeeId");
      const storedUserId = localStorage.getItem("USERID");

      if (formDataAdditional.repeatVisit == 1) {
        const formattedData = {
          ...formData,
          visitorName: formData.firstName,
          appointmentstatus: "Scheduled",
          userId: parseInt(storedUserId, 10),
          employeeId: parseInt(empIDget, 10),
          meetingOn: toLocalISOString(new Date(formData.meetingOn)),
          meetingTo: toLocalISOString(new Date(formData.meetingTo)),
          assitanceRequired: formDataAdditional.assistanceRequired,
          serviceProviderAccess: formDataAdditional.serviceProviderAccess,
          wifiRequired: formDataAdditional.wifiRequired,
          escort: formDataAdditional.escortRequired,
          additionalNotification:
            formDataAdditional.additionalNotification || false,
          isOnBehalfOf: formDataAdditional.isOnBehalfOf || false,
          onBehalfEmployeeId: onBehalfEmployeeId,
          notifyTo: formattedEmails,
          messageToVisitor: formDataAdditional.additionalMessage,
          checkinInstruction: formDataAdditional.checkInInstructions,
          allDay: formDataAdditional.allDay,
          repeatVisit: formDataAdditional.repeatVisit,
          recurrancePattern: formDataAdditional.recurrencePattern,
          recurEvery: parseInt(formDataAdditional.recurEvery, 10),
          selectedRecurrence: formDataAdditional.selectedRecurrence,
          blockCalendar: isBlockCalenderChecked,
        };

        console.log("Form data:", formData);
        console.log("Form data:", formattedData);
        // Proceed with form submission using the formattedData

        try {
          const appId = await insertAppointment(formattedData);
          setAppId(appId);
          const secretKey = CryptoJS.lib.WordArray.random(128 / 8).toString();
          console.log("Generated Secret Key:", secretKey);

          const encryptedAppId = CryptoJS.AES.encrypt(
            appId,
            "secretKey",
          ).toString(); // Encrypt the appId
          localStorage.setItem("appId", encryptedAppId); // Store encrypted appId in local storage

          //localStorage.setItem('appId', appId); // Store appId in local storage
          console.log("encryptedAppId", encryptedAppId);

          console.log("appointment id", appId);

          // Call the second API with appointmentId
          const linkMailAndSmsResponse = await linkMailAndSms(appId);
          setLinkMailAndSmsResponse(linkMailAndSmsResponse);
          console.log("Link Mail and SMS Response:", linkMailAndSmsResponse);
          if (appId == "-1") {
            toast.error("Appointment Already Exists!");
            return;
          }

          if (appId) {
            toast.success(
              "Form Submitted successfully Please check the Email for Appointment!",
            );
            handleReset();
            setTimeout(() => {
              navigate("/layout/LinkToVisitor/LinkToVisitor");
            }, 2000);
          } else {
            toast.error("Failed to book appointment");
          }
        } catch (error) {
          console.error("Error booking appointment:", error);
          toast.error("Failed to book appointment");
        }
      } else if (formDataAdditional.repeatVisit == 0) {
        const formattedData = {
          ...formData,
          visitorName: formData.firstName,
          appointmentstatus: "Scheduled",
          userId: parseInt(storedUserId, 10),
          employeeId: parseInt(empIDget, 10),
          meetingOn: toLocalISOString(new Date(formData.meetingOn)),
          meetingTo: toLocalISOString(new Date(formData.meetingTo)),
          allDay: isAllDayChecked,
          blockCalendar: isBlockCalenderChecked,
          assitanceRequired: formDataAdditional.assistanceRequired,
          serviceProviderAccess: formDataAdditional.serviceProviderAccess,
          wifiRequired: formDataAdditional.wifiRequired,
          escort: formDataAdditional.escortRequired,
          additionalNotification:
            formDataAdditional.additionalNotification || false,
          isOnBehalfOf: formDataAdditional.isOnBehalfOf || false,
          onBehalfEmployeeId: onBehalfEmployeeId,
          notifyTo: formattedEmails,
          messageToVisitor: formDataAdditional.additionalMessage,
          checkinInstruction: formDataAdditional.checkInInstructions,
        };

        console.log("Form data:", formData);
        console.log("Form data:", formattedData);
        // Proceed with form submission using the formattedData

        try {
          const appId = await insertAppointment(formattedData);
          setAppId(appId);
          const secretKey = CryptoJS.lib.WordArray.random(128 / 8).toString();
          console.log("Generated Secret Key:", secretKey);

          const encryptedAppId = CryptoJS.AES.encrypt(
            appId,
            "secretKey",
          ).toString(); // Encrypt the appId
          localStorage.setItem("appId", encryptedAppId); // Store encrypted appId in local storage

          //localStorage.setItem('appId', appId); // Store appId in local storage
          console.log("encryptedAppId", encryptedAppId);

          console.log("appointment id", appId);

          // Call the second API with appointmentId
          const linkMailAndSmsResponse = await linkMailAndSms(appId);
          setLinkMailAndSmsResponse(linkMailAndSmsResponse);
          console.log("Link Mail and SMS Response:", linkMailAndSmsResponse);
          if (appId == "-1") {
            toast.error("Appointment Already Exists!");
            return;
          }

          if (appId) {
            toast.success(
              "Form Submitted successfully Please check the Email for Appointment!",
            );
            handleReset();
            setTimeout(() => {
              navigate("/layout/LinkToVisitor/LinkToVisitor");
            }, 2000);
          } else {
            toast.error("Failed to book appointment");
          }
        } catch (error) {
          console.error("Error booking appointment:", error);
        }
      }
    }
    const getIdProofTypes = async () => {
      try {
        const types = await fetchIdProofTypes();
        setIdProofTypes(types);
      } catch (error) {
        console.error("Error fetching visitor types:", error);
      }
    };
    const getMeetingvenues = async () => {
      try {
        const venues = await fetchMeetingVenues();
        setMeetingvenues(venues);
        const defaultVenue = venues.find((venue) => venue.defaultLocation);

        if (defaultVenue) {
          setFormData((prev) => ({
            ...prev,
            meetingvenue: defaultVenue.locationName,
          }));

          // Fetch gates for the default location
          const menuNameResponse = await axios.get(
            `/Location/GetGatesByLocationID?locationID=${defaultVenue.id}`,
          );
          setGates(menuNameResponse.data);
          console.log("gates", menuNameResponse.data);

          const defaultVenueGate = menuNameResponse.data.find(
            (venue) => venue.defaultGate,
          );
          console.log("defaultVenueGate", defaultVenueGate);

          if (defaultVenueGate) {
            const gateID = parseInt(defaultVenueGate.id, 10); // Convert to integer if gate.id is a number
            const selectedGateObject = menuNameResponse.data.find(
              (gate) => gate.id === gateID,
            );
            console.log("selectedGateObject", selectedGateObject);

            setSelectedGate(selectedGateObject);
            if (selectedGate) {
              setFormData((prevFormData) => ({
                ...prevFormData,
                gate: selectedGate.name, // Use the gate name in the form data
              }));
            }

            const buildings = await fetchBuildingsByGate(defaultVenueGate.id);
            setBuildings(buildings);
          }
        }
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };
    getMeetingvenues();
    const getNationality = async () => {
      try {
        const nation = await fetchNationality();
        setNationalityList(nation);
        const defaultNation = nation.find((n) => n.isDefault === true);
        if (defaultNation) {
          setFormData((prevData) => ({
            ...prevData,
            nationality: defaultNation.name,
          }));
          setDefaultCode(defaultNation.nationalityCode);
        }
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };
    getIdProofTypes();
    getNationality();
  };
  const onConfirm = async (event) => {
    try {
      const response = await axios.get(
        `/Appointment/GetAppointmentbyHost/${employeeId},${formData.meetingOn}`,
      );

      if (
        response.data &&
        response.data.some((appointment) => {
          const formattedExistingMeetingOn = new Date(appointment.meetingOn)
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");
          const formattedExistingValidTill = new Date(appointment.validTill)
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");
          const formattedFormMeetingOn = new Date(formData.meetingOn)
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");

          // Check if the selected meetingOn time matches an existing appointment's meetingOn or validTill
          return (
            formattedExistingMeetingOn === formattedFormMeetingOn ||
            formattedExistingValidTill === formattedFormMeetingOn
          );
        })
      ) {
        setPopupVisible(false);
        toast.error(
          "An appointment already exists for the selected time. Please choose another time slot.",
        );
        return; // Exit function if the appointment cannot be booked
      }
    } catch (error) {
      console.error("Error checking appointment availability:", error);
      toast.error(
        "Failed to check appointment availability. Please try again.",
      );
      return; // Exit function if there's an error in checking availability
    }

    // Convert date to ISO 8601 format with local time
    const toLocalISOString = (date) => {
      const tzOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
      const localISOTime = new Date(date - tzOffset).toISOString().slice(0, -1); // Remove 'Z' at the end
      return localISOTime + "Z"; // Add 'Z' at the end
    };
    let recurrencePattern = getRecurrencePatternAPIValue();

    let newSelectedRecurrencePattern = "";

    // Determine the selected recurrence pattern based on the recurrencePatternAPI value
    if (recurrencePattern === 1) {
      newSelectedRecurrencePattern = "";
    } else if (recurrencePattern === 2) {
      newSelectedRecurrencePattern = selectedWeekday;
    } else if (recurrencePattern === 3) {
      newSelectedRecurrencePattern = selectedMonth;
    }

    // Log the new selected recurrence pattern before setting the state
    console.log(
      "Selected Recurrence Pattern before update:",
      newSelectedRecurrencePattern,
    );
    const formattedEmails = selectedEmails.join(", ");
    console.log("Submitting Emails:", formattedEmails);
    const formDataAdditional = {
      repeatVisit: isChecked,
      recurrencePattern: recurrencePatternAPI,
      selectedRecurrence: String(newSelectedRecurrencePattern),
      selectedDay: selectedDay,
      selectedWeekday: selectedWeekdayAPI,
      selectedMonth: selectedMonthAPI,
      recurEvery: recurEvery,
      allDay: isAllDayChecked,
      blockCalendar: isBlockCalenderChecked,
      assistanceRequired: isAssistanceRequired,
      serviceProviderAccess: isServiceProviderAccess,
      wifiRequired: isWiFiRequired,
      escortRequired: isEscortRequired,
      additionalNotification: isadditionalNotify || false,
      isOnBehalfOf: isbehalfNotify || false,
      onBehalfEmployeeId: onBehalfEmployeeId,
      additionalMessage: additionalMessage,
      checkInInstructions: checkInInstructions,
    };
    const empIDget = localStorage.getItem("employeeId");

    console.log("FormData", formData);
    const storedUserId = localStorage.getItem("USERID");

    if (formDataAdditional.repeatVisit == 1) {
      const formattedData = {
        ...formData,
        visitorName: formData.firstName,
        appointmentstatus: "Scheduled",
        userId: parseInt(storedUserId, 10),
        employeeId: parseInt(empIDget, 10),
        meetingOn: toLocalISOString(new Date(formData.meetingOn)),
        meetingTo: toLocalISOString(new Date(formData.meetingTo)),
        assitanceRequired: formDataAdditional.assistanceRequired,
        serviceProviderAccess: formDataAdditional.serviceProviderAccess,
        wifiRequired: formDataAdditional.wifiRequired,
        escort: formDataAdditional.escortRequired,
        additionalNotification:
          formDataAdditional.additionalNotification || false,
        isOnBehalfOf: formDataAdditional.isOnBehalfOf || false,
        onBehalfEmployeeId: onBehalfEmployeeId,
        notifyTo: formattedEmails,
        messageToVisitor: formDataAdditional.additionalMessage,
        checkinInstruction: formDataAdditional.checkInInstructions,
        allDay: formDataAdditional.allDay,
        repeatVisit: formDataAdditional.repeatVisit,
        recurrancePattern: formDataAdditional.recurrencePattern,
        recurEvery: parseInt(formDataAdditional.recurEvery, 10),
        selectedRecurrence: formDataAdditional.selectedRecurrence,
        blockCalendar: isBlockCalenderChecked,
      };

      console.log("Form data:", formData);
      console.log("Form data:", formattedData);
      // Proceed with form submission using the formattedData

      try {
        const appId = await insertAppointment(formattedData);
        setAppId(appId);
        const secretKey = CryptoJS.lib.WordArray.random(128 / 8).toString();
        console.log("Generated Secret Key:", secretKey);

        const encryptedAppId = CryptoJS.AES.encrypt(
          appId,
          "secretKey",
        ).toString(); // Encrypt the appId
        localStorage.setItem("appId", encryptedAppId); // Store encrypted appId in local storage

        //localStorage.setItem('appId', appId); // Store appId in local storage
        console.log("encryptedAppId", encryptedAppId);

        console.log("appointment id", appId);

        // Call the second API with appointmentId
        const linkMailAndSmsResponse = await linkMailAndSms(appId);
        setLinkMailAndSmsResponse(linkMailAndSmsResponse);
        console.log("Link Mail and SMS Response:", linkMailAndSmsResponse);

        if (appId == "-1") {
          toast.error("Appointment Already Exists!");
          return;
        }

        if (appId) {
          toast.success(
            "Form Submitted successfully Please check the Email for Appointment!",
          );
          handleReset();
          setTimeout(() => {
            navigate("/layout/LinkToVisitor/LinkToVisitor");
          }, 3000);
        } else {
          toast.error("Failed to book appointment");
        }
      } catch (error) {
        console.error("Error booking appointment:", error);
        toast.error("Failed to book appointment");
      }
    } else if (formDataAdditional.repeatVisit == 0) {
      const formattedData = {
        ...formData,
        visitorName: formData.firstName,
        appointmentstatus: "Scheduled",
        userId: parseInt(storedUserId, 10),
        employeeId: parseInt(empIDget, 10),
        meetingOn: toLocalISOString(new Date(formData.meetingOn)),
        meetingTo: toLocalISOString(new Date(formData.meetingTo)),
        allDay: isAllDayChecked,
        blockCalendar: isBlockCalenderChecked,
        assitanceRequired: formDataAdditional.assistanceRequired,
        serviceProviderAccess: formDataAdditional.serviceProviderAccess,
        wifiRequired: formDataAdditional.wifiRequired,
        escort: formDataAdditional.escortRequired,
        additionalNotification:
          formDataAdditional.additionalNotification || false,
        isOnBehalfOf: formDataAdditional.isOnBehalfOf || false,
        onBehalfEmployeeId: onBehalfEmployeeId,
        notifyTo: formattedEmails,
        messageToVisitor: formDataAdditional.additionalMessage,
        checkinInstruction: formDataAdditional.checkInInstructions,
      };

      console.log("Form data:", formData);
      console.log("Form data:", formattedData);
      // Proceed with form submission using the formattedData

      try {
        const appId = await insertAppointment(formattedData);
        setAppId(appId);
        const secretKey = CryptoJS.lib.WordArray.random(128 / 8).toString();
        console.log("Generated Secret Key:", secretKey);

        const encryptedAppId = CryptoJS.AES.encrypt(
          appId,
          "secretKey",
        ).toString(); // Encrypt the appId
        localStorage.setItem("appId", encryptedAppId); // Store encrypted appId in local storage

        //localStorage.setItem('appId', appId); // Store appId in local storage
        console.log("encryptedAppId", encryptedAppId);

        console.log("appointment id", appId);

        // Call the second API with appointmentId
        const linkMailAndSmsResponse = await linkMailAndSms(appId);
        setLinkMailAndSmsResponse(linkMailAndSmsResponse);
        console.log("Link Mail and SMS Response:", linkMailAndSmsResponse);

        if (appId == "-1") {
          toast.error("Appointment Already Exists!");
          return;
        }

        if (appId) {
          toast.success(
            "Form Submitted successfully Please check the Email for Appointment!",
          );
          handleReset();
          setTimeout(() => {
            navigate("/layout/LinkToVisitor/LinkToVisitor");
          }, 3000);
        } else {
          toast.error("Failed to book appointment");
        }
      } catch (error) {
        console.error("Error booking appointment:", error);
      }
    }
    setPopupVisible(false);
    const getNationality = async () => {
      try {
        const nation = await fetchNationality();
        setNationalityList(nation);
        const defaultNation = nation.find((n) => n.isDefault === true);
        if (defaultNation) {
          setFormData((prevData) => ({
            ...prevData,
            nationality: defaultNation.name,
          }));
          setDefaultCode(defaultNation.nationalityCode);
        }
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };
    getNationality();
  };
  const onClose = async (event) => {
    try {
      const response = await axios.get(
        `/Appointment/GetAppointmentbyHost/${employeeId},${formData.meetingOn}`,
      );

      if (
        response.data &&
        response.data.some((appointment) => {
          const formattedExistingMeetingOn = new Date(appointment.meetingOn)
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");
          const formattedExistingValidTill = new Date(appointment.validTill)
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");
          const formattedFormMeetingOn = new Date(formData.meetingOn)
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");

          // Check if the selected meetingOn time matches an existing appointment's meetingOn or validTill
          return (
            formattedExistingMeetingOn === formattedFormMeetingOn ||
            formattedExistingValidTill === formattedFormMeetingOn
          );
        })
      ) {
        setPopupVisible(false);
        toast.error(
          "An appointment already exists for the selected time. Please choose another time slot.",
        );
        return; // Exit function if the appointment cannot be booked
      }
    } catch (error) {
      console.error("Error checking appointment availability:", error);
      toast.error(
        "Failed to check appointment availability. Please try again.",
      );
      return; // Exit function if there's an error in checking availability
    }

    // Convert date to ISO 8601 format with local time
    const toLocalISOString = (date) => {
      const tzOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
      const localISOTime = new Date(date - tzOffset).toISOString().slice(0, -1); // Remove 'Z' at the end
      return localISOTime + "Z"; // Add 'Z' at the end
    };
    let recurrencePattern = getRecurrencePatternAPIValue();

    let newSelectedRecurrencePattern = "";

    // Determine the selected recurrence pattern based on the recurrencePatternAPI value
    if (recurrencePattern === 1) {
      newSelectedRecurrencePattern = "";
    } else if (recurrencePattern === 2) {
      newSelectedRecurrencePattern = selectedWeekday;
    } else if (recurrencePattern === 3) {
      newSelectedRecurrencePattern = selectedMonth;
    }

    // Log the new selected recurrence pattern before setting the state
    console.log(
      "Selected Recurrence Pattern before update:",
      newSelectedRecurrencePattern,
    );
    const formattedEmails = selectedEmails.join(", ");
    console.log("Submitting Emails:", formattedEmails);
    const formDataAdditional = {
      repeatVisit: isChecked,
      recurrencePattern: recurrencePatternAPI,
      selectedRecurrence: String(newSelectedRecurrencePattern),
      selectedDay: selectedDay,
      selectedWeekday: selectedWeekdayAPI,
      selectedMonth: selectedMonthAPI,
      recurEvery: recurEvery,
      allDay: isAllDayChecked,
      blockCalendar: isBlockCalenderChecked,
      assistanceRequired: isAssistanceRequired,
      serviceProviderAccess: isServiceProviderAccess,
      wifiRequired: isWiFiRequired,
      escortRequired: isEscortRequired,
      additionalNotification: isadditionalNotify || false,
      isOnBehalfOf: isbehalfNotify || false,
      onBehalfEmployeeId: onBehalfEmployeeId,
      additionalMessage: additionalMessage,

      checkInInstructions: checkInInstructions,
    };
    const empIDget = localStorage.getItem("employeeId");
    console.log("FormData", formData);

    const storedUserId = localStorage.getItem("USERID");

    if (formDataAdditional.repeatVisit == 1) {
      const formattedData = {
        ...formData,
        visitorName: formData.firstName,
        appointmentstatus: "Scheduled",
        userId: parseInt(storedUserId, 10),
        employeeId: parseInt(empIDget, 10),
        visitorName: existingData.visitorName,
        meetingOn: toLocalISOString(new Date(formData.meetingOn)),
        meetingTo: toLocalISOString(new Date(formData.meetingTo)),
        assitanceRequired: formDataAdditional.assistanceRequired,
        serviceProviderAccess: formDataAdditional.serviceProviderAccess,
        wifiRequired: formDataAdditional.wifiRequired,
        escort: formDataAdditional.escortRequired,
        additionalNotification:
          formDataAdditional.additionalNotification || false,
        isOnBehalfOf: formDataAdditional.isOnBehalfOf || false,
        onBehalfEmployeeId: onBehalfEmployeeId,
        notifyTo: formattedEmails,
        messageToVisitor: formDataAdditional.additionalMessage,
        checkinInstruction: formDataAdditional.checkInInstructions,
        allDay: formDataAdditional.allDay,
        repeatVisit: formDataAdditional.repeatVisit,
        recurrancePattern: formDataAdditional.recurrencePattern,
        recurEvery: parseInt(formDataAdditional.recurEvery, 10),
        selectedRecurrence: formDataAdditional.selectedRecurrence,
        blockCalendar: isBlockCalenderChecked,
      };

      console.log("Form data:", formData);
      console.log("Form data:", formattedData);
      // Proceed with form submission using the formattedData

      try {
        const appId = await insertAppointment(formattedData);
        setAppId(appId);
        const secretKey = CryptoJS.lib.WordArray.random(128 / 8).toString();
        console.log("Generated Secret Key:", secretKey);

        const encryptedAppId = CryptoJS.AES.encrypt(
          appId,
          "secretKey",
        ).toString(); // Encrypt the appId
        localStorage.setItem("appId", encryptedAppId); // Store encrypted appId in local storage

        //localStorage.setItem('appId', appId); // Store appId in local storage
        console.log("encryptedAppId", encryptedAppId);

        console.log("appointment id", appId);

        // Call the second API with appointmentId
        const linkMailAndSmsResponse = await linkMailAndSms(appId);
        setLinkMailAndSmsResponse(linkMailAndSmsResponse);
        console.log("Link Mail and SMS Response:", linkMailAndSmsResponse);

        if (appId == "-1") {
          toast.error("Appointment Already Exists!");
          return;
        }

        if (appId) {
          toast.success(
            "Form Submitted successfully Please check the Email for Appointment!",
          );
          handleReset();
          setTimeout(() => {
            navigate("/layout/LinkToVisitor/LinkToVisitor");
          }, 3000);
        } else {
          toast.error("Failed to book appointment");
        }
      } catch (error) {
        console.error("Error booking appointment:", error);
        toast.error("Failed to book appointment");
      }
    } else if (formDataAdditional.repeatVisit == 0) {
      const formattedData = {
        ...formData,
        visitorName: formData.firstName,
        appointmentstatus: "Scheduled",
        userId: parseInt(storedUserId, 10),
        employeeId: parseInt(empIDget, 10),
        visitorName: existingData.visitorName,
        meetingOn: toLocalISOString(new Date(formData.meetingOn)),
        meetingTo: toLocalISOString(new Date(formData.meetingTo)),
        allDay: isAllDayChecked,
        blockCalendar: isBlockCalenderChecked,
        assitanceRequired: formDataAdditional.assistanceRequired,
        serviceProviderAccess: formDataAdditional.serviceProviderAccess,
        wifiRequired: formDataAdditional.wifiRequired,
        escort: formDataAdditional.escortRequired,
        additionalNotification:
          formDataAdditional.additionalNotification || false,
        isOnBehalfOf: formDataAdditional.isOnBehalfOf || false,
        onBehalfEmployeeId: onBehalfEmployeeId,
        notifyTo: formattedEmails,
        messageToVisitor: formDataAdditional.additionalMessage,
        checkinInstruction: formDataAdditional.checkInInstructions,
      };

      console.log("Form data:", formData);
      console.log("Form data:", formattedData);
      // Proceed with form submission using the formattedData

      try {
        const appId = await insertAppointment(formattedData);
        setAppId(appId);
        const secretKey = CryptoJS.lib.WordArray.random(128 / 8).toString();
        console.log("Generated Secret Key:", secretKey);

        const encryptedAppId = CryptoJS.AES.encrypt(
          appId,
          "secretKey",
        ).toString(); // Encrypt the appId
        localStorage.setItem("appId", encryptedAppId); // Store encrypted appId in local storage

        //localStorage.setItem('appId', appId); // Store appId in local storage
        console.log("encryptedAppId", encryptedAppId);

        console.log("appointment id", appId);

        // Call the second API with appointmentId
        const linkMailAndSmsResponse = await linkMailAndSms(appId);
        setLinkMailAndSmsResponse(linkMailAndSmsResponse);
        console.log("Link Mail and SMS Response:", linkMailAndSmsResponse);

        if (appId == "-1") {
          toast.error("Appointment Already Exists!");
          return;
        }

        if (appId) {
          toast.success(
            "Form Submitted successfully Please check the Email for Appointment!",
          );
          handleReset();
          navigate("/layout/LinkToVisitor/LinkToVisitor");
        } else {
          toast.error("Failed to book appointment");
        }
      } catch (error) {
        console.error("Error booking appointment:", error);
      }
    }
    setPopupVisible(false);
    const getNationality = async () => {
      try {
        const nation = await fetchNationality();
        setNationalityList(nation);
        const defaultNation = nation.find((n) => n.isDefault === true);
        if (defaultNation) {
          setFormData((prevData) => ({
            ...prevData,
            nationality: defaultNation.name,
          }));
          setDefaultCode(defaultNation.nationalityCode);
        }
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };
    getNationality();
  };
  const [locationsGet, setLocationsGet] = useState([]);
  const handleChangeLo = async (e) => {
  const { name, value } = e.target;

  setFormData((prevData) => ({
    ...prevData,
    [name]: value,
    ...(name === "meetingvenue" ? { gate: "", building: "" } : {}),
  }));

  if (formErrors[name]) {
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false,
    }));
  }

  if (name === "meetingvenue") {
    setGates([]);
    setBuildings([]);
    setSelectedGate(null);
  }

  const selectedLocation = meetingvenues.find(
    (item) => item.locationName === value,
  );
  if (selectedLocation) {
    try {
      const menuNameResponse = await axios.get(
        `/Location/GetGatesByLocationID?locationID=${selectedLocation.id}`,
      );
      setGates(menuNameResponse.data);

      // Fetch buildings by location using new API
      const buildingsResponse = await axios.get(
        `/Location/GetBuildingAndGateByLocationId/${selectedLocation.id}`,
      );
      setBuildings(buildingsResponse.data?.data?.buildings || []);
    } catch {
      toast.error("Error fetching gates or areas");
    }
  }
};

  const handleGateChange = async (event) => {
  const gateID = event.target.value;

  if (!gateID) {
    setSelectedGate(null);
    setFormData((prev) => ({ ...prev, gate: "", building: "" }));
    return;
  }

  const selectedGateObject = gates.find(
    (gate) => gate.id === parseInt(gateID, 10),
  );
  setSelectedGate(selectedGateObject);

  setFormData((prev) => ({
    ...prev,
    gate: gateID,
    building: "",
  }));
  // No building fetch here anymore
};

  const handleChange = async (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: false,
      });
    }
  };

  const handleChangeNew = (e) => {
    const { name, value } = e.target;
    console.log("visitor type", e.target.value);
    const selectedText = e.target.options[e.target.selectedIndex].text; // Get the selected text
    console.log("Selected text:", selectedText);
    const selectedType = visitorTypes.find(
      (type) => type.id === parseInt(value),
    );
    console.log("Selected Visitor Type Object:", selectedType);

    if (selectedText == "Service Engineer") {
      console.log("show instruction");
      setCheckInInstructions(`Use Hard Hat and Eye Protection in the Working Zone.Use Hand protection Gloves, Safety Shoe and Belts while working in the site.Use well Insulated wiring, proper plugs while using any electrical Machine.Use proper Scaffolding while working at Heights.

      `);
    } else if (selectedType) {
      setCheckInInstructions(selectedType.checkinInstruction || "");
    }

    setFormData({
      ...formData,
      [name]: value,
    });
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: false,
      });
    }
  };

  // const handleDateChange = (date, name) => {
  //   setFormData({
  //     ...formData,
  //     [name]: date,
  //   });
  // };
  const handleDateChange = (date, field) => {
  console.log("Selected date:", date, "Field:", field);

  if (
    date &&
    Object.prototype.toString.call(date) === "[object Date]" &&
    !isNaN(date)
  ) {
    const now = new Date();
    const isTimeUnchanged =
      date.getHours() === 0 &&
      date.getMinutes() === 0 &&
      date.getSeconds() === 0;

    let finalDate = date;

    if (isTimeUnchanged) {
      finalDate = new Date(date);

      if (field === "meetingTo" && formData.meetingOn) {
        // Set Meeting To = Meeting On time + 30 mins
        const meetingOnDate = new Date(formData.meetingOn);
        finalDate.setHours(meetingOnDate.getHours(), meetingOnDate.getMinutes() + 30, 0, 0);
      } else {
        // Set to current time for Meeting On
        finalDate.setHours(now.getHours(), now.getMinutes(), 0, 0);
      }
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: finalDate,
    }));

    if (formErrors[field]) {
      setFormErrors((prevFormErrors) => ({
        ...prevFormErrors,
        [field]: false,
      }));
    }
  } else {
    console.error("Invalid date value:", date);
  }
};

  const currentDateTime = new Date(); // Current date and time

  // Function to filter out times earlier than the current time
  const filterPassedTime = (time) => {
    if (!(time instanceof Date)) return false;

    const selectedDate = new Date(time);
    const now = new Date();

    const { startHour, startMinute, endHour, endMinute } = timeLimits;

    const selectedMinutes =
      selectedDate.getHours() * 60 + selectedDate.getMinutes();
    const startMinutes = startHour * 60 + startMinute;
    const endMinutes = endHour * 60 + endMinute;

    const isWithinWorkingHours =
      selectedMinutes >= startMinutes && selectedMinutes <= endMinutes;

    const isSameDay = now.toDateString() === selectedDate.toDateString();
    const isFutureTime = selectedDate.getTime() > now.getTime();

    return isWithinWorkingHours && (!isSameDay || isFutureTime);
  };

  // Function to highlight the current time
  const highlightTime = (time) => {
    if (!(time instanceof Date)) return ""; // Ensure 'time' is a valid Date object

    const now = new Date();
    const timeToHighlight = now.getHours() * 60 + now.getMinutes();
    const selectedTime = time.getHours() * 60 + time.getMinutes();

    return selectedTime === timeToHighlight ? "highlight-time" : "";
  };

  const validateMeetingTimes = () => {
  if (formData.meetingOn && formData.meetingTo) {
    const meetingOnDate = moment(formData.meetingOn);
    const meetingToDate = moment(formData.meetingTo);
    const now = moment();

    // Check if Meeting On is at least 5 mins from current time
    const minMeetingOn = now.clone().subtract(5, 'minutes');
    if (meetingOnDate.isBefore(minMeetingOn)) {
      toast.error("Meeting On Time is not Valid");
      setFormErrors((prevFormErrors) => ({
        ...prevFormErrors,
        meetingOn: true,
      }));
      return false;
    }

    // basic check: meeting to must be after meeting on
    if (meetingOnDate.isSameOrAfter(meetingToDate)) {
      toast.error("Meeting To date/time must be greater than Meeting On date/time");
      setFormErrors((prevFormErrors) => ({
        ...prevFormErrors,
        meetingTo: true,
      }));
      return false;
    }

    // Check if Meeting To is at least 15 mins after Meeting On
    const minMeetingTo = meetingOnDate.clone().add(15, 'minutes');
    if (meetingToDate.isBefore(minMeetingTo)) {
      toast.warning("Meeting To Time is less than 15 mins");
      setFormErrors((prevFormErrors) => ({
        ...prevFormErrors,
        meetingTo: true,
      }));
      return false;
    }

    // If both dates are on the same day and Repeat Visit is checked, block it
    if (
      meetingOnDate.isSame(meetingToDate, "day") &&
      isChecked
    ) {
      toast.error("Select more than one day for Repeat Visit.");
      setFormErrors((prevFormErrors) => ({
        ...prevFormErrors,
        meetingTo: true,
      }));
      return false;
    }

    // If meetingOn is today and meetingTo is a later day, require repeat visit
    if (
      meetingOnDate.isSame(now, "day") &&
      meetingToDate.isAfter(now, "day") &&
      !isChecked
    ) {
      toast.error("Please select the Repeat Visit");
      setFormErrors((prevFormErrors) => ({
        ...prevFormErrors,
        meetingTo: true,
      }));
      return false;
    }
  }
  return true;
};

  const adjustForTimezoneOffset = (date) => {
    if (!(date instanceof Date)) return null; // Ensure 'date' is a valid Date object
    const timezoneOffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
    const localISOTime = new Date(date.getTime() - timezoneOffset)
      .toISOString()
      .slice(0, -1);
    return localISOTime;
  };

  useEffect(() => {
    if (visitorTypeDetails) {
      setFormData((prevData) => ({
        ...prevData,
        selectedVisitorTypeId: visitorTypeDetails.id,
      }));
    }
    const getVisitorTypes = async () => {
      const storedEmpId = localStorage.getItem("employeeId");
      try {
        const types = await axios.get(
          `/VisitorType/GetVisitorTypeDetailsByEmpId/${storedEmpId}`,
        );
        setVisitorTypes(types.data);
      } catch (error) {
        console.error("Error fetching visitor types:", error);
      }
    };
    const getIdProofTypes = async () => {
      try {
        const types = await fetchIdProofTypes();
        setIdProofTypes(types);
      } catch (error) {
        console.error("Error fetching visitor types:", error);
      }
    };

    const getMeetingvenues = async () => {
      try {
        const venues = await fetchMeetingVenues();
        setMeetingvenues(venues);
        const defaultVenue = venues.find((venue) => venue.defaultLocation);

        if (defaultVenue) {
        setFormData((prev) => ({
          ...prev,
          meetingvenue: defaultVenue.locationName,
        }));

        const menuNameResponse = await axios.get(
          `/Location/GetGatesByLocationID?locationID=${defaultVenue.id}`,
        );
        setGates(menuNameResponse.data);

        // Fetch buildings by location using new API
        const buildingsResponse = await axios.get(
          `/Location/GetBuildingAndGateByLocationId/${defaultVenue.id}`,
        );
        setBuildings(buildingsResponse.data?.data?.buildings || []);

        const defaultVenueGate = menuNameResponse.data.find(
          (venue) => venue.defaultGate,
        );
        if (defaultVenueGate) {
          const gateID = parseInt(defaultVenueGate.id, 10);
          const selectedGateObject = menuNameResponse.data.find(
            (gate) => gate.id === gateID,
          );
          setSelectedGate(selectedGateObject);
        }
      }
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };
    const getNationality = async () => {
      try {
        const nation = await fetchNationality();
        setNationalityList(nation);
        const defaultNation = nation.find((n) => n.isDefault === true);
        if (defaultNation) {
          setFormData((prevData) => ({
            ...prevData,
            nationality: defaultNation.name,
          }));
          setDefaultCode(defaultNation.nationalityCode);
        }
      } catch (error) {
        console.error("Error fetching meeting venues:", error);
      }
    };
    const getMeetiingOn = async () => {
      try {
        const response = await axios.get(
          "/Appointment/GetMeetingFromAndMeetingTo",
        );
        const { meetingFrom, meetingTo } = response.data;

        const [startHour, startMinute] = meetingFrom.split(":").map(Number);
        const [endHour, endMinute] = meetingTo.split(":").map(Number);

        setTimeLimits({ startHour, startMinute, endHour, endMinute });
      } catch (error) {
        console.error("Error fetching meeting time limits:", error);
      }
    };
    getMeetiingOn();
    // x
    getIdProofTypes();

    getVisitorTypes();
    getNationality();
    getMeetingvenues();
    // getGateDetails();
  }, []);
  useEffect(() => {
    if (selectedGate) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        gate: selectedGate.name, // Use the gate name in the form data
      }));
    }
  }, [selectedGate]);

  // const handleGateChange = async (event) => {
  //   const gateID = event.target.value;

  //   // If no gate is selected, clear selectedGate and formData.gate
  //   if (!gateID) {
  //     setSelectedGate(null);
  //     setFormData({ ...formData, gate: '' });
  //     setBuildings([]);
  //     return;
  //   }

  //   const selectedGateObject = gates.find(gate => gate.id === parseInt(gateID, 10));
  //   setSelectedGate(selectedGateObject);
  //   setFormData({ ...formData, gate: gateID });

  //   try {
  //     const buildings = await fetchBuildingsByGate(gateID);
  //     setBuildings(buildings);
  //   } catch (error) {
  //     console.error('Error fetching buildings:', error);
  //   }
  // };

  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleFirstNameChange = async (e) => {
    const { value } = e.target;

    // Allow only alphabets and spaces
    if (!/^[A-Za-z\s]*$/.test(value)) return;

    setFormData((prev) => ({ ...prev, firstName: value }));

    // Clear error if present
    if (formErrors.firstName) {
      setFormErrors((prev) => ({ ...prev, firstName: false }));
    }

    const visitorTypeId = formData.selectedVisitorTypeId; // ✅ make sure this persists after reset

    if (value.length >= 3 && visitorTypeId) {
      try {
        const response = await axios.get(
          `Appointment/GetAppointmentDetailsByVisitorNameAndVisitorTypeId`,
          {
            params: {
              VisitorName: value,
              visitorTypeId: visitorTypeId,
            },
          },
        );
        setSuggestions(response.data || []);
        setShowSuggestions(true);
      } catch (error) {
        console.error("API error:", error);
        setSuggestions([]);
      }
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClickF = async (item) => {
    const matchedNationality = nationalityList.find(
      (nat) => nat.id === item.nationalityId,
    );

    // Match building by name
    const matchMeetingVenu = meetingvenues.find(
      (venue) => venue.locationName === item.meetingvenue,
    );
    console.log("matchMeetingVenu", matchMeetingVenu);

    const menuNameResponse = await axios.get(
      `/Location/GetGatesByLocationID?locationID=${matchMeetingVenu.id}`,
    );
    setGates(menuNameResponse.data);
    console.log("gates", menuNameResponse.data);

    const selectedGateObject = menuNameResponse.data.find(
      (gate) => gate.id === item.gateId,
    );
    console.log("selectedGateObject", selectedGateObject);

    setSelectedGate(selectedGateObject);
    if (selectedGate) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        gate: selectedGate.name, // Use the gate name in the form data
      }));
    }
    // const buildings = await fetchBuildingsByGate(selectedGateObject?.id);
    // setBuildings(buildings);
    // Fetch buildings by location using new API
    const buildingsResponse = await axios.get(
      `/Location/GetBuildingAndGateByLocationId/${matchMeetingVenu.id}`,
    );
    setBuildings(buildingsResponse.data?.data?.buildings || []);
    const matchedBuilding = buildingsResponse.data?.data?.buildings?.find((bld) => bld.name === item.building);

    // setIsChecked(item.repeatVisit);
    //   setRecurrencePattern(item.recurrancePattern === null ? null : item.recurrancePattern === 1 ? "1" : item.recurrancePattern === 2 ? "2" : "3"); // Set to default value (1 for Daily)
    //   setSelectedDay(item.selectedRecurrence);
    //   setSelectedWeekday(item.selectedRecurrence);
    //   setSelectedMonth(item.selectedRecurrence);
    //   setRecurEvery(item.recurEvery);
    setIsAllDayChecked(item.allDay);
    setIsBlockCalenderChecked(item.blockCalendar);
    setIsAssistanceRequired(item.assitanceRequired);
    setIsServiceProviderAccess(item.serviceProviderAccess);
    setIsWiFiRequired(item.wifiRequired);
    setIsEscortRequired(item.escort);
    setAdditionalMessage(item.messageToVisitor);
    setCheckInInstructions(item.checkinInstruction);
    setIsAdditionalNotify(item.additionalNotification);
    setIsBehalfNotify(item.isOnBehalfOf);

    // if (item.notifyTo) {
    //   setSelectedEmails(item.notifyTo?.split(",").map((email) => email.trim()));
    // }

    setFormData((prev) => ({
      ...prev,
      firstName: item.firstName,
      middleName: item.middleName || "",
      lastName: item.lastName || "",
      gender: item.gender || "",
      visitorEmail: item.visitorEmail || "",
      nationality: matchedNationality.name || "",
      visitorMobile: item.visitorMobile || "",
      building: matchedBuilding?.name || "",
      purpose: item.purpose || "",
      meetingvenue: item.meetingvenue || "",
    }));
    setDefaultCode(matchedNationality.nationalityCode);
    // if (item?.notifyTo) {
    //   setSelectedEmails(item?.notifyTo?.split(",").map((email) => email.trim()));
    // }

    console.log("Selected visitor data:", item);
    setShowSuggestions(false);
  };

  const handleAddChange = (e) => {
    const { name, value, type, checked } = e.target;

    // For checkboxes, use checked value, otherwise use value
    const newValue = type === "checkbox" ? checked : value;

    setFormData({
      ...formData,
      [name]: newValue, // Dynamically update the specific field in formData
    });
  };
  const handleSwitchChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <Container>
      <Header>
        <Heading>Book Appointment</Heading>
        <ButtonGroup>
          <ResetButton onClick={handleReset}>Reset</ResetButton>
          <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
        </ButtonGroup>
      </Header>
      {/* Tabs Section */}
      <Tabs>
        <Tab
          active={activeTab === "details"}
          onClick={() => setActiveTab("details")}
        >
          Details
        </Tab>
        <Tab
          active={activeTab === "additional"}
          onClick={() => setActiveTab("additional")}
        >
          Additional
        </Tab>
      </Tabs>

      {/* Tab Contents */}
      <TabContent active={activeTab === "details"}>
        <CardContainer>
          <Card>
            <FormGroup>
              <Label>
                Visitor Type
                <Asterisk> *</Asterisk>
              </Label>
              <Select
                name="selectedVisitorTypeId"
                value={formData.selectedVisitorTypeId}
                onChange={handleChangeNew}
                disabled
              >
                <option value="">Select Visitor Type</option>
                {visitorTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.visitorTypeDesc}
                  </option>
                ))}
              </Select>
              {formErrors.selectedVisitorTypeId && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a visitor type
                </span>
              )}
            </FormGroup>
            <FormRow>
              <FormGroup style={{ position: "relative" }}>
                <Label>
                  First Name
                  {fieldData.visitorNameField && <Asterisk> *</Asterisk>}
                </Label>
                <Input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleFirstNameChange}
                  placeholder="Enter First Name"
                  style={{
                    borderColor: formErrors.firstName ? "red" : "#2B3497",
                  }}
                  autoComplete="off"
                  onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                  onKeyDown={(e) => {
                    if (e.key === 'Escape') setShowSuggestions(false);
                  }}
                />
                {formErrors.firstName && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    Please fill in the first name
                  </span>
                )}

                {/* Elegant Suggestions Dropdown */}
                {showSuggestions && suggestions.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      zIndex: 999,
                      maxHeight: "200px",
                      overflowY: "auto",
                    }}
                  >
                    {suggestions.map((item, index) => (
                      <div
                        key={index}
                        // onClick={() => handleSuggestionClickF(item)}
                        onMouseDown={(e) => {
                          e.preventDefault(); // Prevents onBlur from firing before selection
                          handleSuggestionClickF(item);
                        }}
                        style={{
                          padding: "10px 15px",
                          cursor: "pointer",
                          borderBottom:
                            index !== suggestions.length - 1
                              ? "1px solid #eee"
                              : "none",
                          transition: "background 0.2s",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f0f4ff")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "#fff")
                        }
                      >
                        <span style={{ fontWeight: "500", color: "#293495" }}>
                          {item.visitorName}
                        </span>
                        <span
                          style={{
                            color: "#666",
                            fontSize: "12px",
                            marginLeft: "8px",
                          }}
                        >
                          ({item.visitorCompany})
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </FormGroup>

              <FormGroup>
                <Label>Middle Name</Label>
                <Input
                  type="text"
                  name="middleName"
                  value={formData.middleName}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Regular expression to only allow alphabets and spaces
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      handleChange(e); // Only update state if input is valid
                    }
                  }}
                  placeholder="Enter Middle Name (Optional)"
                  style={{ borderColor: "#2B3497" }}
                />
              </FormGroup>

              <FormGroup>
                <Label>
                  Last Name
                  {fieldData.visitorNameField && <Asterisk> *</Asterisk>}
                </Label>
                <Input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Regular expression to only allow alphabets and spaces
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      handleChange(e); // Only update state if input is valid
                    }
                  }}
                  placeholder="Enter Last Name"
                  style={{
                    borderColor: formErrors.lastName ? "red" : "#2B3497",
                  }}
                />
                {formErrors.lastName && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    Please fill in the last name
                  </span>
                )}
              </FormGroup>
            </FormRow>
            {/* <FormGroup>

              <Label>
                Visitor Name
                <Asterisk> *</Asterisk>
              </Label>
              <Input
                type="text"
                name="visitorName"
                value={formData.visitorName}
                onChange={(e) => {
                  const value = e.target.value;
                  // Regular expression to only allow alphabets and spaces
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleChange(e); // Only update state if input is valid
                  }
                }}
                placeholder="Enter Visitor Name"
                style={{ borderColor: formErrors.visitorName ? 'red' : '#2B3497' }}
              />
              {formErrors.visitorName && (
                <span style={{ color: 'red', fontSize: '12px' }}>Please fill in the visitor name</span>
              )}

            </FormGroup> */}
            <FormGroup>
              <Label>
                Visitor Email
                {fieldData.visitorEmailField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="email"
                name="visitorEmail"
                value={formData.visitorEmail}
                onChange={handleChange}
                placeholder="Enter Visitor E-mail"
                style={{
                  borderColor: formErrors.visitorEmail ? "red" : "#2B3497",
                }}
              />
              {formErrors.visitorEmail && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formData.visitorEmail
                    ? "Invalid email format"
                    : "Please fill in the visitor email"}
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Gender
                {fieldData.genderField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="other">Other</option>
              </Select>
              {formErrors.gender && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a gender
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Nationality
                {fieldData.nationalityField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="nationality"
                value={formData.nationality}
                onChange={(e) => {
                  const selectedNationality = nationalityList.find(
                    (n) => n.name === e.target.value,
                  );
                  setFormData({
                    ...formData,
                    nationality: e.target.value,
                    visitorMobile: "", // Clear mobile number when nationality changes
                  });
                  setDefaultCode(selectedNationality.nationalityCode);
                }}
              >
                <option value="">Select Nationality</option>
                {nationalityList.map((nationality) => (
                  <option
                    key={nationality.id}
                    value={nationality.name}
                    disabled={nationality.isBlackListed}
                  >
                    {nationality.name}
                  </option>
                ))}
              </Select>
              {formErrors.nationality && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a nationality
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Visitor Mobile
                {fieldData.visitorMobileField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="visitorMobile"
                value={formData.visitorMobile}
                onChange={handleChange}
                placeholder="Enter  Mobile Number"
                maxLength={defaultCode === "91" ? 10 : 15}
                onInput={(e) => {
                  // Remove non-numeric characters
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                }}
                style={{
                  borderColor: formErrors.visitorMobile ? "red" : "2B3497",
                }}
              />
              {formErrors.visitorMobile && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {formData.visitorMobile
                    ? "Invalid mobile number"
                    : "Please fill in the mobile number"}
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Purpose
                {fieldData.purpose && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="purpose"
                value={formData.purpose}
                onChange={handleChange}
                placeholder="Enter Purpose"
              />
              {formErrors.purpose && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please fill in the purpose
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Location
                {fieldData.locationField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="meetingvenue"
                value={formData.meetingvenue}
                onChange={handleChangeLo}
              >
                <option value="">Select Location</option>
                {meetingvenues.map((type) => (
                  <option
                    key={type.id}
                    value={type.locationName}
                    name={type.id}
                  >
                    {type.locationName}
                  </option>
                ))}
              </Select>
              {formErrors.meetingvenue && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a location
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Gate
                {fieldData.gateField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="gate"
                value={selectedGate ? selectedGate.id : ""}
                onChange={handleGateChange}
              >
                <option value="">Select Gate</option>
                {gates.map((gate) => (
                  <option key={gate.id} value={gate.id}>
                    {gate.name}
                  </option>
                ))}
              </Select>
              {formErrors.gate && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a gate
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Area
                {fieldData.areaField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="building"
                value={formData.building}
                onChange={handleChange}
              >
                <option value="">Select Area</option>
                {Array.isArray(buildings) &&
                  buildings.map((building) => (
                    <option key={building.id} value={building.name}>
                      {building.name}
                    </option>
                  ))}
              </Select>
              {formErrors.building && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a building
                </span>
              )}
            </FormGroup>
          </Card>
          <Card>
            <FormGroup>
              <Label>
                Meeting On
                {fieldData.meetingOnField && <Asterisk> *</Asterisk>}
              </Label>
              <StyledDatePicker
                selected={
                  formData.meetingOn instanceof Date ? formData.meetingOn : null
                }
                onChange={(date) => handleDateChange(date, "meetingOn")}
                showTimeSelect
                dateFormat="Pp"
                minDate={currentDateTime}
                filterTime={filterPassedTime}
                timeClassName={highlightTime}
                placeholderText="Select Meeting Start Date and Time"
              />
              {formErrors.meetingOn && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a meeting start time
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Meeting To
                {fieldData.meetingToField && <Asterisk> *</Asterisk>}
              </Label>
              <StyledDatePicker
                selected={
                  formData.meetingTo instanceof Date ? formData.meetingTo : null
                }
                onChange={(date) => handleDateChange(date, "meetingTo")}
                showTimeSelect
                dateFormat="Pp"
                minDate={formData.meetingOn || currentDateTime} // Ensure meetingTo is after meetingOn
                filterTime={filterPassedTime}
                timeClassName={highlightTime}
                placeholderText="Select Meeting End Date and Time"
              />
              {formErrors.meetingTo && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a meeting end time
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Id Proof Type
                {fieldData.idProofTypeField && <Asterisk> *</Asterisk>}
              </Label>
              <Select
                name="idProofId"
                value={formData.idProofId}
                onChange={handleChange}
              >
                <option value="">Select ID Proof Type</option>
                {idProofTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.idProofDescription}
                  </option>
                ))}
              </Select>
              {formErrors.idProofId && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please select a Id Prood type
                </span>
              )}
            </FormGroup>
            <FormGroup>
              <Label>
                Id Proof Number
                {fieldData.idProofNumberField && <Asterisk> *</Asterisk>}
              </Label>
              <Input
                type="text"
                name="visitorIdNumber"
                maxLength={4}
                value={formData.visitorIdNumber}
                onChange={handleChange}
                placeholder="Enter Id Proof Number"
                style={{
                  borderColor: formErrors.visitorIdNumber ? "red" : "2B3497",
                }}
              />
              {formErrors.visitorIdNumber && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please Fill the Id Proof Number
                </span>
              )}
              {/* <input
                type="text"
                name="visitorIdNumber"
                placeholder="Enter Id Proof Number"
                value={formData.visitorIdNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  const regex = /^[a-zA-Z0-9]*$/;
                  if (value === '' || regex.test(value)) {
                    handleInputChange(e);
                  }
                }}
                style={{ border: '1px solid black', padding: '5px', width: '100%' }}
              />
              {formErrors.visitorIdNumber && (
                <span style={{ color: 'red', fontSize: '12px' }}>
                  Please Fill the Id Proof Number
                </span>
              )} */}
            </FormGroup>

            <AdditionalInputContainerN>
              <CheckboxContainer>
                <CheckboxLabel>All Day</CheckboxLabel>
                <Checkbox
                  type="checkbox"
                  checked={isAllDayChecked}
                  onChange={handleAllDayCheckboxChange}
                />
              </CheckboxContainer>
            </AdditionalInputContainerN>
            <AdditionalInputContainerN>
              <CheckboxContainer>
                <CheckboxLabel>Block calendar</CheckboxLabel>
                <Checkbox
                  type="checkbox"
                  checked={isBlockCalenderChecked}
                  onChange={handleBlockCalenderCheckboxChange}
                />
              </CheckboxContainer>
            </AdditionalInputContainerN>
            <CheckboxContainer>
              <CheckboxLabel>Repeat Visit</CheckboxLabel>
              <Checkbox
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
            </CheckboxContainer>

            <HeaderN>Scheduler</HeaderN>

            <DropdownContainer>
              <DropdownLabel>Recurrence Pattern:</DropdownLabel>
              <StyledDropdown
                value={recurrencePattern}
                onChange={handleDropdownChange}
                disabled={!isChecked}
              >
                <option value="" disabled>
                  Select pattern
                </option>
                <option value="1">Daily</option>
                <option value="2">Weekly</option>
                <option value="3">Monthly</option>
              </StyledDropdown>
            </DropdownContainer>

            {/* Daily input for selecting the day */}
            {/* <InputContainer show={recurrencePattern === '1'}>
              <SpinnerInputLabel>Recur Every:</SpinnerInputLabel>
              <SpinnerInput type="number" min="1" max="31" value={selectedDay} onChange={handleDayChange} />
            </InputContainer> */}

            {/* Weekly dropdown for selecting the weekday */}
            <InputContainer show={recurrencePattern === "2"}>
              <DropdownLabel>Select Weekdays:</DropdownLabel>
              <CheckboxContainernew>
                {[
                  "Sunday",
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                ].map((day, index) => (
                  <CheckboxLabelnew key={index}>
                    <Checkbox
                      type="checkbox"
                      disabled={!isChecked}
                      checked={selectedWeekday.includes(index + 1)}
                      onChange={() => handleWeekdayCheckboxChange(index + 1)}
                    />
                    {day}
                  </CheckboxLabelnew>
                ))}
              </CheckboxContainernew>
            </InputContainer>

            {/* Monthly dropdown for selecting the month */}
            <InputContainer show={recurrencePattern === "3"}>
              <DropdownLabel>Select Months:</DropdownLabel>
              <CheckboxContainernewM>
                {[
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ].map((month, index) => (
                  <CheckboxLabelnew key={index}>
                    <Checkbox
                      type="checkbox"
                      disabled={!isChecked}
                      checked={selectedMonth.includes(index + 1)}
                      onChange={() => handleMonthCheckboxChange(index + 1)}
                    />
                    {month}
                  </CheckboxLabelnew>
                ))}
              </CheckboxContainernewM>
            </InputContainer>

            {/* All Day checkbox and Recur Every input */}
            <InputContainer
              show={
                recurrencePattern === "2" ||
                recurrencePattern === "3" ||
                recurrencePattern === "1"
              }
            >
              <SpinnerInputLabel>Recur Every:</SpinnerInputLabel>
              <RecurrenceInput
                type="number"
                min="0"
                value={recurEvery}
                disabled={!isChecked}
                onChange={handleRecurEveryChange}
                onKeyDown={handleRecurEveryKeyDown}
              />
            </InputContainer>

            {/* <AdditionalInputContainer show={recurrencePattern === '2' || recurrencePattern === '3'}>
              <CheckboxContainer>
                <CheckboxLabel>All Day</CheckboxLabel>
                <Checkbox type="checkbox" checked={isAllDayChecked} onChange={handleAllDayCheckboxChange} />
              </CheckboxContainer>
            </AdditionalInputContainer> */}

            {/* New Section for Selected Values */}
          </Card>
        </CardContainer>
      </TabContent>
      {/* Additional Tab Content */}
      <TabContent active={activeTab === "additional"}>
        <CardContainer>
          <Card>
            <SwitchContainer>
              <SwitchRow>
                <SwitchLabel>Assistance Required</SwitchLabel>
                <Switch
                  isOn={isAssistanceRequired}
                  onClick={toggleAssistanceRequired}
                >
                  <SwitchSlider isOn={isAssistanceRequired} />
                  <SwitchText isOn={isAssistanceRequired}>
                    {isAssistanceRequired ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>

              <SwitchRow>
                <SwitchLabel>Service Provider Access</SwitchLabel>
                <Switch
                  isOn={isServiceProviderAccess}
                  onClick={toggleServiceProviderAccess}
                >
                  <SwitchSlider isOn={isServiceProviderAccess} />
                  <SwitchText isOn={isServiceProviderAccess}>
                    {isServiceProviderAccess ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>

              <SwitchRow>
                <SwitchLabel>WiFi Required</SwitchLabel>
                <Switch isOn={isWiFiRequired} onClick={toggleWiFiRequired}>
                  <SwitchSlider isOn={isWiFiRequired} />
                  <SwitchText isOn={isWiFiRequired}>
                    {isWiFiRequired ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>

              <SwitchRow>
                <SwitchLabel>Escort Required</SwitchLabel>
                <Switch isOn={isEscortRequired} onClick={toggleEscortRequired}>
                  <SwitchSlider isOn={isEscortRequired} />
                  <SwitchText isOn={isEscortRequired}>
                    {isEscortRequired ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>
              <SwitchRow>
                <SwitchLabel> Additional Notification</SwitchLabel>
                <Switch
                  isOn={isadditionalNotify}
                  onClick={toggleadditionalNotifyRequired}
                >
                  <SwitchSlider isOn={isadditionalNotify} />
                  <SwitchText isOn={isadditionalNotify}>
                    {isadditionalNotify ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>
              <SwitchRow>
                <SwitchLabel> On Behalf</SwitchLabel>
                <Switch
                  isOn={isbehalfNotify}
                  onClick={togglebehalfNotifyRequired}
                >
                  <SwitchSlider isOn={isbehalfNotify} />
                  <SwitchText isOn={isbehalfNotify}>
                    {isbehalfNotify ? "Yes" : "No"}
                  </SwitchText>
                </Switch>
              </SwitchRow>
            </SwitchContainer>
            <InputFieldContainer>
              <InputLabelN>
                On Behalf Notify to:{isbehalfNotify && <Asterisk> *</Asterisk>}
              </InputLabelN>
              <ChipContainer>
                {onBehalfEmail && (
                  <Chip>
                    {onBehalfEmail}
                    <RemoveChipButton onClick={() => setOnBehalfEmail("")}>
                      &times;
                    </RemoveChipButton>
                  </Chip>
                )}
                {!onBehalfEmail && (
                  <InputField
                    value={inputValueBehalf}
                    onChange={handleBehalfInputChange}
                    placeholder="Enter email ID"
                    disabled={!isbehalfNotify}
                  />
                )}
              </ChipContainer>
              {filteredBehalfSuggestions.length > 0 && (
                <SuggestionBox>
                  {filteredBehalfSuggestions.map((emp) => (
                    <SuggestionItem
                      key={emp.id}
                      onClick={() =>
                        handleBehalfSuggestionClick(emp.employeeMailId)
                      }
                    >
                      {emp.employeeMailId} - {emp.employeeName}
                    </SuggestionItem>
                  ))}
                </SuggestionBox>
              )}
            </InputFieldContainer>
            <InputFieldContainer>
              <InputLabelN>
                Notify to:{isadditionalNotify && <Asterisk> *</Asterisk>}
              </InputLabelN>
              <ChipContainer>
                {selectedEmails.map((email, index) => (
                  <Chip key={index}>
                    {email}
                    <RemoveChipButton onClick={() => handleChipRemove(email)}>
                      &times;
                    </RemoveChipButton>
                  </Chip>
                ))}
                <InputField
                  value={inputValue}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  disabled={!isadditionalNotify}
                  placeholder="Enter email ID"
                />
              </ChipContainer>
              {filteredSuggestions.length > 0 && (
                <SuggestionBox>
                  {filteredSuggestions.map((emp) => (
                    <SuggestionItem
                      key={emp.id}
                      onClick={() => handleSuggestionClick(emp.employeeMailId)}
                    >
                      {emp.employeeMailId} - {emp.employeeName}
                    </SuggestionItem>
                  ))}
                </SuggestionBox>
              )}
            </InputFieldContainer>

            {/* Additional Input Fields */}
            <InputFieldContainer>
              <InputLabel>Message to Visitors:</InputLabel>
              <StyledTextArea
                value={additionalMessage}
                onChange={handleAdditionalMessageChange}
                placeholder="Enter message here"
                rows={recurrencePattern === "1" ? 3 : 6} // Adjust as needed for the number of lines shown by default
              />
            </InputFieldContainer>

            <InputFieldContainer>
              <InputLabel>Check-In Instructions:</InputLabel>
              <StyledTextArea
                value={checkInInstructions}
                onChange={handleCheckInInstructionsChange}
                placeholder="Enter instructions here"
                rows={recurrencePattern === "1" ? 3 : 6} // Adjust as needed for the number of lines shown by default
              />
            </InputFieldContainer>
          </Card>
        </CardContainer>
      </TabContent>

      <ToastContainer />
      {isPopupVisible && (
        <Popup>
          <PopupText>
            {existingData.visitorName}- Name is exists for this number. Click
            update to save new name or Click cancel
          </PopupText>
          <ButtonContainer>
            <PopupButton onClick={onConfirm}>Update</PopupButton>
            <PopupButton className="no-button" onClick={onClose}>
              Cancel
            </PopupButton>
          </ButtonContainer>
        </Popup>
      )}
    </Container>
  );
};

export default BookAppointment;
